import React, { useContext, useEffect, useState } from "react";
import "./GreenTarrifficationForm.scss";
import "./GreenStepsStyles.scss";
import { Select } from "../../../components/inputs/Select";
import { mapVehicleFields, Vehicle } from "../../../model/vehicle";
import { QuotationContext } from "../../../contexts/QuotationContext";
import { MtplQuotation } from "../../../model/quotation";
import { strings } from "../../../strings/strings";
import { InfoView } from "../../../components/InfoView/infoView";
import { PhoneAndDateBirthForms } from "../forms/PhoneAndDateBirthForms";
import { selectedViewEnam } from "../../../model/pageEnam";
import { GreenTarifficationInputView } from "./InputView/GreenTarifficationInputView";
import { VehicleSearchView } from "../forms/Tariffication/VehicleSearch/VehicleSearchView";
import { TarifficationDescription } from "../forms/Tariffication/TarifficationDescription";
import { useHotjar } from "../../../utils/hooks/useHotjar";
import { PartyType } from "../../../model/party";
import { ErrorDialogType } from "../../../utils/hooks/useErrorDialog";

interface Props {
    onFormSubmit: () => void;
    setErrorDialogType: (errorDialogType: ErrorDialogType) => void;
    setTextErrorMessageDialog: (string) => void;
    setOpenErrorMessageDialog: (bool) => void;
}

export const GreenTarrifficationForm = ({ onFormSubmit, setOpenErrorMessageDialog, setErrorDialogType, setTextErrorMessageDialog }: Props) => {
    const {
        quotation,
        selectedView,
        setSelectedView,
        vehicleFounded,
        setVehicleFounded,
        setQuotation,
        type
    } = useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const [defaultVehicle, setDefaultVehicle] = useState<Vehicle>(quotation.mtplContract.vehicle);
    const onBack = () => {
        emptyVehicleFields();
        setVehicleFounded(false);
        setSelectedView(selectedViewEnam.NEWCLIENT);
    }

    const { trackHotjar } = useHotjar()

    useEffect(() => {
        if (selectedView === selectedViewEnam.NEWCLIENT) {
            trackHotjar("", type)
        } else if (selectedView === selectedViewEnam.ARXCLIENT) {
            trackHotjar("login", type)
        }
    }, [selectedView])

    useEffect(() => {
        let event = 'green_card_shop_buy';
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({ 'event': event });
    }, []);

    const resetVehicleFields = () => {
        const newQuotation = { ...quotation };
        newQuotation.mtplContract.vehicle = { ...defaultVehicle };
        setQuotation(newQuotation);
    };

    const emptyVehicleFields = () => {
        const newQuotation = { ...quotation };
        newQuotation.mtplContract.vehicle = {
            id: null,
            vehicleType: null,
            brand: null,
            model: null,
            plateNumber: null,
            vin: null,
            constructionYear: null,
            engineType: null,
            batteryCapacity: null,
            colour: null,
            registerCity: null,
            ownerPartyType: "PERSON",
            ownerBirthYear: null,
            taxiUsage: null,
            requiredTO: null,
            nextToDate: null,
        } as Vehicle;
        setDefaultVehicle(newQuotation.mtplContract.vehicle);
        setQuotation(newQuotation);
    };


    const onSearchListener = (vehicle: Vehicle) => {
        if (vehicle.ownerPartyType === PartyType.ORGANIZATION) {
            setErrorDialogType(ErrorDialogType.NONE);
            setTextErrorMessageDialog(strings.smartDriveVehicleTypeMismatchError);
            setOpenErrorMessageDialog(true);
            setSelectedView(selectedViewEnam.MANUAL);
            return;
        }
        resetVehicleFields();
        const updatedVehicle = mapVehicleFields(vehicle, quotation.mtplContract.vehicle);
        setQuotation({
            ...quotation,
            mtplContract: {
                ...quotation.mtplContract,
                vehicle: updatedVehicle
            }
        })
        setVehicleFounded(true);
    };

    const tarificationDescription = () => <TarifficationDescription
        title={strings.tarifficationDescriptionHeaderGreenCard}
        lines={[strings.tarifficationDescriptionGreenCardElement1, strings.tarifficationDescriptionGreenCardElement2]} />

    return (
        <div className={'step-form'}>
            {(selectedView !== selectedViewEnam.MANUAL && selectedView !== selectedViewEnam.SECONDSEARCH) && (
                <div className="step-form__toolbar">
                    <div className="align-near">
                        <Select defaultValue={selectedView} onValueSelect={setSelectedView}
                            items={[
                                { label: strings.toolbarNewClient, id: 'toolbarNewClient', value: selectedViewEnam.NEWCLIENT },
                                { label: strings.toolbarARXClient, id: 'toolbarARXClient', value: selectedViewEnam.ARXCLIENT }
                            ]} />
                        <InfoView />
                    </div>
                </div>
            )}

            {selectedView === selectedViewEnam.ARXCLIENT && (
                <PhoneAndDateBirthForms setOpenErrorMessageDialog={setOpenErrorMessageDialog}
                    setTextErrorMessageDialog={setTextErrorMessageDialog}
                    description={tarificationDescription} />
            )}

            {(selectedView === selectedViewEnam.NEWCLIENT || selectedView === selectedViewEnam.SECONDSEARCH) && (vehicleFounded ? (
                <GreenTarifficationInputView onSubmit={onFormSubmit} onBackListener={onBack} />
            ) : (
                <VehicleSearchView
                    plateNumberDescription={strings.greenByNumberSearchDescription}
                    description={tarificationDescription}
                    onSearchListener={onSearchListener}
                    toManualInputListener={() => {
                        setSelectedView(selectedViewEnam.MANUAL);
                        // const event = quotation.salesVariant === 'svs_05910264_package' ? '_SD_go_manual' : 'mtpl_go_manual'
                        // console.log('Google Analytics Event = ' + event);
                        // // @ts-ignore
                        // window.dataLayer.push({'event': event});
                    }} />

            ))}

            {selectedView === selectedViewEnam.MANUAL && (
                <GreenTarifficationInputView onSubmit={onFormSubmit} onBackListener={onBack} />
            )}


        </div>
    )

};